import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
} from "react-bootstrap";
import { zipSurveyStatusAndStw } from "../../helper/surveyUtils";
import { Patient } from "../../services/getFunctions";
import { useNavigate } from "react-router";
import { SurveyStatusAndStws } from "../../types/surveyTypes";
import { getGermanTodayIso } from "../../helper/dateHelpers";

interface ResultStateModalProps {
  currentPatient: Patient;
  modalResultOpen: boolean;
  closeResultModal: () => void;
  clinic_id: string;
  clinic_name: string;
  username: string;
}

const ResultStateModal = ({
  currentPatient,
  modalResultOpen,
  closeResultModal,
  clinic_id,
  clinic_name,
  username,
}: ResultStateModalProps) => {
  const navigate = useNavigate();

  const [surveyStatusAndStws, setSurveyStatusAndStws] = useState<
    SurveyStatusAndStws[]
  >([]);

  const openClinicianReport = (
    event,
    id,
    stwType,
    surveyStart,
    surveyUpdate,
  ) => {
    event.preventDefault();
    console.log("event id is: ", id);
    if (id !== "") {
      navigate("/clinician/clinician-report", {
        state: {
          clinic_id: clinic_id,
          clinic_name: clinic_name,
          username: username,
          survey_session_id: id,
          patient_code: currentPatient.code,
          birthday: currentPatient.date_of_birth,
          gender: currentPatient.gender,
          stw_type: stwType,
          started_time: surveyStart,
          update_time: surveyUpdate,
        },
      });
    }
  };

  const getSeverityStyle = (
    status: SurveyStatusAndStws,
  ): React.CSSProperties => {
    const now = getGermanTodayIso();
    const basicStyle = {
      textDecoration: "none",
    };
    const noLinkStyle = {
      cursor: "default",
    };
    const linkStyle = {
      cursor: "pointer",
      textDecoration: "underline",
      fontWeight: "bold",
    };
    if (!status.surveyState.finished && status.stw_end < now) {
      // "Abgelaufen"
      return {
        ...basicStyle,
        ...noLinkStyle,
        color: "FireBrick",
      };
    } else if (
      !status.surveyState.survey_session_id ||
      !status.surveyState.finished
    ) {
      return {
        ...basicStyle,
        ...noLinkStyle,
        color: "#767676",
      };
    }

    let color;
    switch (status.surveyState.condition_severity) {
      case "LOW":
        color = "green";
        break;
      case "MEDIUM":
        color = "#b35900";
        break;
      case "HIGH":
        color = "#c00000";
        break;
      case "UNKNOWN":
        color = "black";
        break;
      case "ERROR":
      default:
        color = "black";
    }
    return {
      ...basicStyle,
      ...linkStyle,
      color,
    };
  };

  useEffect(() => {
    if (modalResultOpen) {
      const surveyStatuses = currentPatient.survey_statuses;
      const stws = currentPatient.survey_time_windows;

      let stwsArray;
      if (Array.isArray(stws)) {
        stwsArray = stws;
      } else if (stws && typeof stws === "object" && "stws" in stws) {
        stwsArray = (stws as { stws: unknown }).stws;
      } else {
        stwsArray = [];
      }

      const zippedSurveyStatusAndStws = zipSurveyStatusAndStw(
        stwsArray as Parameters<typeof zipSurveyStatusAndStw>[0],
        surveyStatuses,
      );

      setSurveyStatusAndStws(zippedSurveyStatusAndStws);
      console.log("SurveyStatusAndSTWS: ", zippedSurveyStatusAndStws);
    }
  }, [
    modalResultOpen,
    currentPatient.survey_statuses,
    currentPatient.survey_time_windows,
  ]);

  return (
    <div>
      {" "}
      <Modal backdrop="static" show={modalResultOpen} onHide={closeResultModal}>
        <ModalHeader closeButton>
          <ModalTitle>
            Ergebnis von <em>{currentPatient.code}</em>
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
          {surveyStatusAndStws.map((status) => {
            const key = status.stw_start;
            return (
              <div key={key}>
                <div id={status.surveyState.survey_session_id}>
                  {status.stw_type_deutsch}:{" "}
                  <button
                    className="btn btn-link p-0"
                    style={getSeverityStyle(status)}
                    onClick={(event) => {
                      if (
                        status.surveyState.survey_session_id &&
                        status.surveyState.finished
                      ) {
                        openClinicianReport(
                          event,
                          status.surveyState.survey_session_id,
                          status.surveyState.stw_type,
                          status.surveyState.started_time,
                          status.surveyState.update_time,
                        );
                      } else {
                        event.preventDefault();
                        return false;
                      }
                    }}
                  >
                    {status.result_status}
                    {!status.surveyState.report_viewed &&
                      status.surveyState.survey_session_id &&
                      status.surveyState.finished && (
                        <span className="unread-tag" />
                      )}
                  </button>
                </div>
              </div>
            );
          })}
        </ModalBody>
        <ModalFooter></ModalFooter>
      </Modal>
    </div>
  );
};

export default ResultStateModal;
